import React from 'react';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import { OptionsCommon, ShowHideChildOptions } from 'components/show_drawing/redraw_form/index.js';

const FLUTE_DIRECTION_VERTICAL = 1;
const FLUTE_DIRECTION_HORIZONTAL = 0;

const OptionFluteDirection = ({ id, drawing, option, unit, setRedrawRequested, optionsUserChanged, addToOptionsUserChanged }) => {
  const formattedValue = (value) => { return parseFloat(value) }
  const redrawOnChange = true;
  const [isVisible, value, valueAutoCalculated, recommendedValue, onChange, showAbcHelperLine, changed, highlighted, d_input_add_on_ref] = OptionsCommon( { formattedValue, id, drawing, option, unit, optionsUserChanged, addToOptionsUserChanged, setRedrawRequested, redrawOnChange } )

  const onSelectChange = (e) => {
    onChange({ target: { value: parseFloat(e.target.value) } })
  }

  const getShowHideChildOptions = () => {
    if (option.children.length == 0) { return }
    return <ShowHideChildOptions id={id} option={option} />
  }

  if (!isVisible) { return <input type="hidden" name={option.name} value={value} /> }

  return (
    <div className={styles.row}>
      <div className={`input-group ${highlighted ? styles.highlighted : ''}`} style={{ width: '100%' }}>
        <span className={`d_input_add_on input-group-addon input-group-addon-${window.locale} ${styles.input_add_on}`} ref={d_input_add_on_ref}>
          {option.description_en}
        </span>

        <select
          name={option.name}
          value={value}
          onChange={onSelectChange}
          className="drawing-option-input autoredrawonchange form-control"
          disabled={option.readonly_option}
        >
          <option value={FLUTE_DIRECTION_VERTICAL}>{t('drawing.flute_direction_vertical')}</option>
          <option value={FLUTE_DIRECTION_HORIZONTAL}>{t('drawing.flute_direction_horizontal')}</option>
        </select>
      </div>

      {valueAutoCalculated && <> <small> { t('drawing.this_has_been_automaticly_calculated') } </small> { getShowHideChildOptions()} {option.children.length == 0 && <br /> } </> }
      {!valueAutoCalculated && option.value_formula && recommendedValue !== undefined &&  <> <small> {t('drawing.choose_option_recommmended')}: {recommendedValue == FLUTE_DIRECTION_VERTICAL ? t('drawing.flute_direction_vertical') : t('drawing.flute_direction_horizontal')} </small> { getShowHideChildOptions() } </>}
      {!valueAutoCalculated && !(option.value_formula && recommendedValue !== undefined) &&  <> { getShowHideChildOptions() } </>}
    </div>
  )
}

export default OptionFluteDirection;
